   <div class="app-bs-datepicker-container position-relative" [ngClass]="{'opacity-half': isDisabled}">
<input id="dp"
class="input-field"
placeholder="{{plhldr}}"
[class]="datePickerClass "
[minDate]="minDate"
[maxDate]="maxDate"
[disabled]="isDisabled"
#dp="bsDatepicker"
[placement]="componentPlacement"
(onShown)="onShowPicker($event)"
autocomplete="off"
[bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', showWeekNumbers:false, customTodayClass: 'custom-today-class' }"
bsDatepicker (bsValueChange)="onDateChange($event)" [(bsValue)]="value" readonly [ngClass]="{'help-required':isvalid==false}" >
<div class="help-block" id="err_date" *ngIf="isvalid==false">{{errMsg}}</div>
<img *ngIf="isLeftIcon" [ngClass]="{'opacity-half': isDisabled}" (click)="dp.show()" class="calender-icon cursor-text" src="assets/themes/icons/headers/icon-calendar.svg" alt="calender">
</div>
